import { Component, OnInit } from '@angular/core';
import { USER_MENU } from 'base-customer';
import { APPLICATION_SECTIONS_MEDICAL } from '../../_constants/application-sections';
import { BaseEnvironmentService } from 'base';

@Component({
  selector: 'medical-wrapper-component',
  templateUrl: './wrapper.component.html',
})
export class WrapperComponent implements OnInit {
  logo = '';
  logoSmall = '';

  sections = APPLICATION_SECTIONS_MEDICAL;
  userMenu = USER_MENU;

  constructor(private environmentService: BaseEnvironmentService) {}

  ngOnInit() {
    this.logo = this.environmentService.getLocalValue('application').logo;
    this.logoSmall = this.environmentService.getLocalValue('application').logoSmall;
  }
}
